import React from 'react'
import { styled } from '@mui/material/styles'
import { EmtButton, EmtIcon, EmtModal, EmtTheme, EmtTypography } from 'emt-components-v2'
import Box from '@mui/material/Box'

type Props = React.PropsWithChildren<{
  open: boolean
  title: string
  text: string
  icon: string
  confirmButtonLabel: string
  rejectButtonLabel: string
  onConfirm: () => void
  onReject: () => void
}>

type EmtThemeType = { theme: EmtTheme }

const StyledAttentionCircleEmtIcon = styled(EmtIcon)<EmtThemeType>(({ theme }) => ({
  color: theme.palette.greyGradient[150],
  fontSize: 40,
})) as typeof EmtIcon

export const ValidationModal: React.FC<Props> = ({
  open,
  title,
  text,
  confirmButtonLabel,
  rejectButtonLabel,
  icon,
  onConfirm,
  onReject,
}) => {
  return (
    <EmtModal
      open={open}
      variant="default"
      onClose={onReject}
      sx={{
        '& .inner-box': { maxWidth: 450 },
        '& .emt-x': { display: 'none' },
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center ',
          flexDirection: 'column',
          rowGap: '10px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center ',
            flexDirection: 'column',
            rowGap: '20px',
          }}
        >
          <StyledAttentionCircleEmtIcon className={icon} />
          <EmtTypography variant="h4" fontWeight={800}>
            {title}
          </EmtTypography>
        </Box>
        <EmtTypography variant="body1">{text}</EmtTypography>
        <EmtButton fullWidth sx={{ marginTop: '10px' }} onClick={onConfirm}>
          {confirmButtonLabel}
        </EmtButton>
        <EmtButton variant="whiteOutlined" fullWidth sx={{ border: 0 }} onClick={onReject}>
          {rejectButtonLabel}
        </EmtButton>
      </Box>
    </EmtModal>
  )
}
